import { createContext } from 'react';

const TableBodyContext = createContext();

export default TableBodyContext;
